// modal/detail/panels/LogsPanel.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import Chip from '@mui/material/Chip';
import Icon from '@mui/material/Icon';

import { moneyTry } from '../../../utils/staffFormatters';
import { SoftCard } from 'shared/ui/soft/SoftCard';
import { LogItem } from '../ui/LogItem';
import { PillIcon } from 'shared/ui/soft/PillIcon';

export function LogsPanel({ active, logs }) {
  if (!active) return <div style={{ display: 'none' }} />;

  return (
    <SoftCard>
      <MDBox display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1.25 }}>
        <MDBox display="flex" alignItems="center" gap={1}>
          <PillIcon icon="manage_search" tone="blue" />
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
              Aktivite Logları
            </MDTypography>
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Ödeme aldı • Üye ekledi • Seans oluşturdu…
            </MDTypography>
          </MDBox>
        </MDBox>

        <Chip
          size="small"
          icon={<Icon sx={{ fontSize: 16, color: '#2196f3' }}>bolt</Icon>}
          label="Canlı / filtre (mock)"
          variant="outlined"
          sx={{ borderRadius: '999px', fontWeight: 800 }}
        />
      </MDBox>

      <MDBox sx={{ display: 'grid', gap: 0.9 }}>
        {logs.map((l, idx) => {
          if (l.type === 'PAYMENT') {
            return (
              <LogItem
                key={idx}
                tone="teal"
                icon="payments"
                title={l.title}
                meta={l.meta}
                right={
                  <Chip
                    size="small"
                    label={moneyTry(l.amount)}
                    variant="outlined"
                    sx={{
                      borderRadius: '999px',
                      fontWeight: 900,
                      borderColor: 'rgba(0,150,136,.25)',
                      background: 'rgba(0,150,136,.06)',
                    }}
                  />
                }
              />
            );
          }
          if (l.type === 'MEMBER_ADD') {
            return (
              <LogItem key={idx} tone="violet" icon="person_add" title={l.title} meta={l.meta} />
            );
          }
          return <LogItem key={idx} tone="amber" icon="event" title={l.title} meta={l.meta} />;
        })}
      </MDBox>

      <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 1 }}>
        (Sonraki adım) Filtreler: tarih aralığı, tip, tutar, hedef üye, işlem yapan.
      </MDTypography>
    </SoftCard>
  );
}
